const typographyModalPlaces = {
  true: 'Editar ',
  false: 'Cadastrar ',
  text: 'Raíz'
};

export default typographyModalPlaces;
